import { createAsyncThunk } from '@reduxjs/toolkit'
import { cartManagementApi } from 'src/api/cart-management'
import { IQuery } from 'src/interfaces/cart-management'

export const getListCartAction = createAsyncThunk(
  'cart/get-list-carts',
  async ({ limit = 10, ...otherParams }: IQuery) => {
    try {
      const res = await cartManagementApi.getListCarts({
        limit,
        ...otherParams,
      })
      return res
    } catch (error) {
      throw error
    }
  }
)
